import { ADD_FILTER, CLEAR_FILTER} from './actionType';

export const addFilter = (payload) => {
  return {
    type: ADD_FILTER,
    payload
  }
}

export const clearFilter = () => {
  return {
    type: CLEAR_FILTER
  }
}